import React, { useState, Fragment } from 'react'

import PropTypes from 'prop-types'

import './features251.css'

const Features251 = (props) => {
  const [activeTab, setActiveTab] = useState(2)
  return (
    <div className="thq-section-padding">
      <div className="features251-container2 thq-section-max-width">
        <div className="features251-tabs-menu">
          <div
            onClick={() => setActiveTab(0)}
            className="features251-tab-horizontal1"
          >
            <div className="features251-divider-container1">
              {activeTab === 0 && (
                <div className="features251-container3"></div>
              )}
            </div>
            <div className="features251-content1">
              <h2 className="features251-feature1-title thq-heading-2">
                {props.feature1Title ?? (
                  <Fragment>
                    <span className="features251-text11">
                      Empowerment Through Skills
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature1Description ?? (
                  <Fragment>
                    <span className="features251-text14">
                      <span>Provide individuals and organisation with the</span>
                      <br></br>
                      <span>right skills to unlock potential</span>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(1)}
            className="features251-tab-horizontal2"
          >
            <div className="features251-divider-container2">
              {activeTab === 1 && (
                <div className="features251-container4"></div>
              )}
            </div>
            <div className="features251-content2">
              <h2 className="features251-feature2-title thq-heading-2">
                {props.feature2Title ?? (
                  <Fragment>
                    <span className="features251-text10">Empower Minds</span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small features251-feature2-description">
                {props.feature2Description ?? (
                  <Fragment>
                    <span className="features251-text18">
                      <span>
                        Empower
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <span>
                        individuals &amp; organisations with the knowledge,
                        skills, and  tools they need to harness the power of
                        data and ensure no one is left behind
                      </span>
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div
            onClick={() => setActiveTab(2)}
            className="features251-tab-horizontal3"
          >
            <div className="features251-divider-container3">
              {activeTab === 2 && (
                <div className="features251-container5"></div>
              )}
            </div>
            <div className="features251-content3">
              <h2 className="features251-feature3-title thq-heading-2">
                {props.feature3Title ?? (
                  <Fragment>
                    <span className="features251-text13">
                      Strategic Networking
                    </span>
                  </Fragment>
                )}
              </h2>
              <span className="thq-body-small">
                {props.feature3Description ?? (
                  <Fragment>
                    <span className="features251-text12">
                      We want to build a strong network of strategic partners,
                      interested parties and educators who want to build our
                      nation through education and skills development
                    </span>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="features251-image-container">
          {activeTab === 0 && (
            <img
              alt={props.imageAlt}
              src={props.imageSrc}
              className="features251-image1 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 1 && (
            <img
              alt={props.imageAlt1}
              src={props.imageSrc1}
              className="features251-image2 thq-img-ratio-16-9"
            />
          )}
          {activeTab === 2 && (
            <img
              alt={props.imageAlt2}
              src={props.imageSrc2}
              className="features251-image3 thq-img-ratio-16-9"
            />
          )}
        </div>
      </div>
    </div>
  )
}

Features251.defaultProps = {
  feature2Title: undefined,
  feature1Title: undefined,
  feature3Description: undefined,
  imageAlt: 'image',
  feature3Title: undefined,
  imageSrc:
    'https://images.unsplash.com/photo-1529390079861-591de354faf5?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDI0fHxsZWFybmluZ3xlbnwwfHx8fDE3MzY5NTA4ODh8MA&ixlib=rb-4.0.3&q=80&w=1400',
  feature1Description: undefined,
  imageAlt1: 'image',
  imageSrc2:
    'https://images.unsplash.com/photo-1576267423429-569309b31e84?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDl8fG5ldHdvcmtpbmd8ZW58MHx8fHwxNzM2OTUxMDYwfDA&ixlib=rb-4.0.3&q=80&w=1400',
  imageSrc1:
    'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w5MTMyMXwwfDF8c2VhcmNofDJ8fGJ1c2luZXNzJTIwcG93ZXJ8ZW58MHx8fHwxNzM2OTUwOTg2fDA&ixlib=rb-4.0.3&q=80&w=1400',
  feature2Description: undefined,
  imageAlt2: 'image',
}

Features251.propTypes = {
  feature2Title: PropTypes.element,
  feature1Title: PropTypes.element,
  feature3Description: PropTypes.element,
  imageAlt: PropTypes.string,
  feature3Title: PropTypes.element,
  imageSrc: PropTypes.string,
  feature1Description: PropTypes.element,
  imageAlt1: PropTypes.string,
  imageSrc2: PropTypes.string,
  imageSrc1: PropTypes.string,
  feature2Description: PropTypes.element,
  imageAlt2: PropTypes.string,
}

export default Features251
